module.exports = __webpack_public_path__ + "img/good-with-easter-giving.02c1d80e.png";